import { render, staticRenderFns } from "./TeacherIntroduct.vue?vue&type=template&id=b7a7f72e&scoped=true&"
import script from "./TeacherIntroduct.vue?vue&type=script&lang=js&"
export * from "./TeacherIntroduct.vue?vue&type=script&lang=js&"
import style0 from "./TeacherIntroduct.vue?vue&type=style&index=0&id=b7a7f72e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a7f72e",
  null
  
)

export default component.exports